import { error, redirect, type Load } from '@sveltejs/kit';
import { load as loadBlog } from '@glimja/storefront/pages/blog/[slug]';
import { getLocaleFromUrl } from '@glimja/shared/utils';
import { getBlogSlug } from '../../../../../_api/src/utils/blog';

const getBlog = async (event: Load) => {
  try {
    const data = await loadBlog(event as unknown as any);
    return data;
  } catch (e) {
    error(404, 'Not found')
  }
}

export const load: Load = async (event) => {
  const { url } = event;

  // check if the url has uppercase characters, in that case redirect to lowercase url
  const lowercasePathname = url.pathname.toLowerCase();
  if (url.pathname !== lowercasePathname) {
    const lowercaseUrl = new URL(url.toString());
    lowercaseUrl.pathname = lowercasePathname;
    //  redirect(301, lowercasePathname);
  }

  // Load blog data - this could be either a post or a category
  const data = await getBlog(event as unknown as any) as any;
  const locale = getLocaleFromUrl(url);
  const blogBaseSlug = getBlogSlug(locale.language);

  // Handle slug redirects differently depending on whether it's a post or category
  if (data.isPost && data.post) {
    // For blog posts, extract the last part of the slug
    const slug = data.post.slug.split('/').pop();
    const fullPathName = `${locale.language !== locale.defaultLanguage ? '/' + locale.language : ''}/${blogBaseSlug}/${slug}`;

    if (fullPathName !== lowercasePathname) {
      redirect(301, fullPathName);
    }
  } else if (data.isCategory && data.category) {
    // For categories, use the defaultSlug property if available, otherwise fallback to slug
    const slug = data.category.slug.split('/').pop();
    const fullPathName = `${locale.language !== locale.defaultLanguage ? '/' + locale.language : ''}/${blogBaseSlug}/${slug}`;
    if (fullPathName !== lowercasePathname) {
      redirect(301, fullPathName);
    }
  }
  return data;
};
